(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["experience_lbrgt"] && !Shopify.designMode) return;
  try {
    
(() => {
  const section = document.getElementById('hair-journey');
  if (!section) return;

  const fill = section.querySelector('.progress-fill');
  const steps = Array.from(section.querySelectorAll('.progress-steps span'));
  let ticking = false;

  function update() {
    const { top, height } = section.getBoundingClientRect();
    const viewportH = window.innerHeight;

    const isMobile = window.innerWidth < 768;
    const offset = isMobile ? 5 : 40; // increase offset for mobile

    const progress = Math.min(1, Math.max(0, (viewportH - top) / (viewportH - offset)));

    if (isMobile) {
      fill.style.transform = `scaleY(${progress})`;
    } else {
      fill.style.transform = `scaleX(${progress})`;
    }

    steps.forEach((el, i) => {
      const threshold = i / (steps.length - 1) - 0.05;
      el.classList.toggle('is-active', progress >= threshold);
    });

    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  });

  window.addEventListener('resize', update);
  update(); // Initial run
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our_impact_lbrgt"] && !Shopify.designMode) return;
  try {
    
/* ------- Count-up on scroll ------- */
document.addEventListener("DOMContentLoaded", () => {
  const stats = document.querySelectorAll(".our_impact_h3");
  const observer = new IntersectionObserver(onIntersect, { threshold: 0.4 });

  stats.forEach(stat => observer.observe(stat));

  function onIntersect(entries, obs) {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const numberEl = entry.target.querySelector(".stat__number");
      const target = +entry.target.dataset.percentage;
      animateCount(numberEl, target);
      obs.unobserve(entry.target); // run only once
    });
  }

  function animateCount(el, target) {
    const duration = 3000;             // animation length in ms
    const start = performance.now();

    requestAnimationFrame(function update(now) {
      const progress = Math.min((now - start) / duration, 1);
      el.textContent = Math.round(progress * target);
      if (progress < 1) requestAnimationFrame(update);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline_lbrgt"] && !Shopify.designMode) return;
  try {
    
const timelineItems = document.querySelectorAll('.prose_timeline');
const timelineLine = document.querySelector('.prose_timeline_line');
const timelineGrid = document.getElementById('timeline_grid');

function animateTimeline() {
  const triggerBottom = window.innerHeight / 5 * 4;

  let lastActiveItemBottom = 0;

  timelineItems.forEach(item => {
    const itemRect = item.getBoundingClientRect();
    const itemTop = itemRect.top + 230; // your existing offset

    if(itemTop < triggerBottom) {
      item.classList.add('active');
      // update lastActiveItemBottom to the bottom of this item relative to grid
      const itemOffset = item.offsetTop + item.offsetHeight;
      if(itemOffset > lastActiveItemBottom) lastActiveItemBottom = itemOffset;
    } else {
      item.classList.remove('active');
    }
  });

  // Update timeline line height according to last active item
  timelineLine.style.height = lastActiveItemBottom + 'px';
}

if (timelineLine && timelineItems.length > 0) {
  window.addEventListener('scroll', animateTimeline);
  window.addEventListener('resize', animateTimeline);
  animateTimeline();
}

  } catch(e) { console.error(e); }
})();
})();
